// AI advisor — report generation (en).
window.PlummeI18n.register('en', {
  'adv.cf.cashBasisMissing': 'Cash evidence is unavailable. Balances and movements must reconcile to the ledger.',
  'adv.cf.cashBalanceEvidence': 'Posted cash and bank balance is {amount}. This is not a bank-confirmed balance.',
  'adv.rpt.period.profit': 'In Q{quarter} {year}, revenue is {income} and profit is {result}.',
  'adv.rpt.period.loss': 'In Q{quarter} {year}, revenue is {income} and the loss is {result}.',
  "adv.rpt.period.nativeSuppliers": "Supplier ranking covers dated purchases in the quarter, excluding fixed assets and undated imported annual summaries.",
  "adv.rpt.period.choose": "Period",
  "adv.rpt.period.year": "Full year",
  "adv.rpt.period.yearLabel": "Full year {year}",
  "adv.rpt.period.quarter": "Quarter {quarter}",
  "adv.rpt.period.label": "Q{quarter} {year}",
  "adv.rpt.period.vsQuarter": "vs. the same quarter last year",
  "adv.rpt.period.quarterBasis": "Accounting figures for {from}\u2013{to}. Balance sheet amounts are at period end.",
  "adv.rpt.period.currentStatus": "Follow-up status when generated on {date}. This section uses current open items and the annual overview, not historical quarter-end status.",
  "adv.rpt.period.rolling": "Rolling 12 months through {to}, compared with the preceding 12 months.",
  "adv.rpt.period.nativeSales": "Customer and invoice details cover posted invoices dated within the quarter. Imported annual summaries without a quarterly breakdown are excluded here.",
  "adv.rpt.period.budget": "Actuals in the selected quarter are compared with the budget for those same three months.",
  "adv.rpt.period.pdfUnavailable": "The new PDF layout is not available on the server yet. Try again after the update.",
  "adv.rpt.slides.present": "Present",
  "adv.rpt.slides.exit": "Exit presentation",
  "adv.rpt.slides.readable": "Read page text",
  "adv.rpt.slides.previous": "Previous",
  "adv.rpt.slides.next": "Next",
  "adv.rpt.slides.page": "Page {current} of {total}",
  // ------------------------------------------------------------ Template picker
  'adv.rpt.modal.title': 'Create report',
  'adv.rpt.modal.intro': 'Pick a report template. SuperPlumma pulls the figures from your accounts and assembles a draft you can review before sharing it.',
  'adv.rpt.modal.generate': 'Generate report',
  'adv.rpt.modal.cancel': 'Cancel',
  'adv.rpt.modal.basis': 'Data basis: {sources}',
  'adv.rpt.modal.year': 'Financial year',
  'adv.rpt.modal.saved': 'Saved reports',
  'adv.rpt.modal.savedEmpty': 'You have no saved reports yet.',
  'adv.rpt.modal.open': 'Open',
  'adv.rpt.modal.delete': 'Delete',
  'adv.rpt.modal.deleted': 'Report deleted.',
  'adv.rpt.hero.cta': 'Create report',
  'adv.rpt.saved.title': 'Saved reports',
  'adv.rpt.saved.tab': 'Saved reports',
  'adv.rpt.saved.description': 'Saved reports remain as snapshots and do not change when the accounts are updated.',
  'adv.rpt.saved.count': '{count} of {limit} reports saved',
  'adv.rpt.saved.limitError': 'You can save up to {limit} reports. Delete a report before saving a new one.',
  'adv.rpt.saved.loading': 'Loading saved reports …',
  'adv.rpt.saved.emptyTitle': 'No saved reports',
  'adv.rpt.saved.emptyText': 'Create a report and save it when you want to keep that exact version.',
  'adv.rpt.saved.loadFailed': 'Could not load saved reports.',
  'adv.rpt.saved.deleteFailed': 'Could not delete the report.',

  // ------------------------------------------------------------ Templates
  'adv.rpt.tpl.styre.name': 'Board and management report',
  'adv.rpt.tpl.styre.desc': 'Full report for the board with result, liquidity, risk and recommended actions.',
  'adv.rpt.tpl.manedsrapport.name': 'Monthly report',
  'adv.rpt.tpl.manedsrapport.desc': 'Status for the selected month with budget, prior-year comparison, trend and recommended next steps.',
  'adv.rpt.tpl.likviditet.name': 'Liquidity report',
  'adv.rpt.tpl.likviditet.desc': 'Open items, buffer and running balance based on booked figures.',
  'adv.rpt.tpl.avvik.name': 'Result and variance report',
  'adv.rpt.tpl.avvik.desc': 'The largest variances against budget so far this year, and the cost lines that moved most.',
  'adv.rpt.tpl.kunde.name': 'Customer and sales report',
  'adv.rpt.tpl.kunde.desc': 'Sales development, largest customers, customer concentration and receivables.',
  'adv.rpt.tpl.kostnad.name': 'Cost report',
  'adv.rpt.tpl.kostnad.desc': 'Cost development, the largest suppliers and purchases missing documentation.',
  'adv.rpt.tpl.utestaende.name': 'Open items',
  'adv.rpt.tpl.utestaende.desc': 'Unpaid customer and supplier items split by overdue and not yet due.',
  'adv.rpt.tpl.arsoppsummering.name': 'Year summary',
  'adv.rpt.tpl.arsoppsummering.desc': 'Summarises the whole year — result, balance, sales, costs and risk.',

  'adv.rpt.length.2to3': '2–3 pages',
  'adv.rpt.length.2to4': '2–4 pages',
  'adv.rpt.length.3to5': '3–5 pages',
  'adv.rpt.length.4to6': '4–6 pages',
  'adv.rpt.length.8to12': '8–12 pages',
  'adv.rpt.length.variable': 'Length follows available data',
  'adv.rpt.length.10to14': '10–14 pages',

  // ------------------------------------------------------------ Document
  'adv.rpt.doc.contents': 'Contents',
  'adv.rpt.doc.brand': 'PLUMME / AI ADVISOR',
  'adv.rpt.doc.continued': 'continued',
  'adv.rpt.doc.back': 'Back',
  'adv.rpt.doc.draft': 'Draft',
  'adv.rpt.doc.saved': 'Saved',
  'adv.rpt.doc.save': 'Save',
  'adv.rpt.doc.savedToast': 'Report saved.',
  'adv.rpt.doc.exportPdf': 'Export PDF',
  'adv.rpt.doc.exportPptx': 'Download PowerPoint',
  'adv.rpt.doc.exportingPptx': 'Building PowerPoint …',
  'adv.rpt.doc.exportPptxFailed': 'Could not build the PowerPoint file. Please try again.',
  'adv.rpt.doc.presentation': 'PRESENTATION',
  'adv.rpt.doc.coverFoot': 'Generated from the report data in Plumme',
  'adv.rpt.doc.exporting': 'Building PDF …',
  'adv.rpt.doc.exportFailed': 'Could not build the report file. Please try again.',
  'adv.rpt.doc.period': '{year} · {months} months of the year',
  'adv.rpt.doc.createTask': 'Create task',
  'adv.rpt.doc.taskCreated': 'Added to the action centre with follow-up on {date}.',
  'adv.rpt.doc.taskFailed': 'Could not create the task.',
  'adv.rpt.doc.taskNote': 'Created from {report}.',

  // ------------------------------------------------------------ Narrative (AI)
  'adv.rpt.narr.section': 'Summary from SuperPlumma',
  'adv.rpt.narr.tag': 'Written by SuperPlumma',
  'adv.rpt.narr.idle': 'Let SuperPlumma read the report and write the summary: what is at stake, what actually moved, and what to do now.',
  'adv.rpt.narr.write': 'Write summary',
  'adv.rpt.narr.rewrite': 'Rewrite',
  'adv.rpt.narr.loading': 'SuperPlumma is reading the report …',
  'adv.rpt.narr.failed': 'The summary could not be written. The figures in the report are complete either way.',
  'adv.rpt.narr.drivers': 'What moved',
  'adv.rpt.narr.watch': 'What to watch',
  'adv.rpt.narr.nextStep': 'Next step: ',
  'adv.rpt.narr.foot': 'The summary is written from the figures in this report. Every amount is checked against the report before the text is shown.',

  // ------------------------------------------------------------ Sections
  'adv.rpt.sec.changeSince': 'Changes since the last report',
  'adv.rpt.col.lastReport': 'Last report',
  'adv.rpt.col.now': 'Now',
  'adv.rpt.col.change': 'Change',
  'adv.rpt.note.changeSinceBasis': 'Compared with the report saved on {date}. Those figures are a snapshot and do not change afterwards.',
  'adv.rpt.empty.noPreviousReport': 'This is the first saved report of this kind for the year. Next time, this section shows what changed since now.',
  'adv.rpt.empty.noComparableReport': 'The previous report has no key figures to compare against.',
  'adv.rpt.sec.summary': 'Summary',
  'adv.rpt.sec.events': 'Material events',
  'adv.rpt.sec.keyFigures': 'Key figures',
  'adv.rpt.sec.budget': 'Result against budget',
  'adv.rpt.sec.liquidity': 'Liquidity and payment obligations',
  'adv.rpt.sec.forecast': 'Running balance through the year',
  'adv.rpt.sec.balance': 'Balance sheet and solidity',
  'adv.rpt.sec.resultTrend': 'Result development',
  'adv.rpt.sec.sales': 'Sales and customer development',
  'adv.rpt.sec.customerChange': 'Customer loyalty and payment time',
  'adv.rpt.sec.costTrend': 'Cost development',
  'adv.rpt.sec.suppliers': 'Largest suppliers',
  'adv.rpt.sec.voucherReview': 'Vouchers to review',
  'adv.rpt.sec.receivables': 'Customer items',
  'adv.rpt.sec.payables': 'Supplier items',
  'adv.rpt.sec.risk': 'Risk and uncertainty',
  'adv.rpt.sec.actions': 'Recommended actions',
  'adv.rpt.sec.decisions': 'Matters for decision',
  'adv.rpt.sec.dataBasis': 'Data basis',

  // ------------------------------------------------------------ Analysis (level 2)
  'adv.rpt.sec.bridge': 'What moved the result',
  'adv.rpt.sec.workingCapital': 'Working capital and tied-up time',
  'adv.rpt.sec.rolling': 'Rolling twelve months',
  'adv.rpt.col.driver': 'Driver',
  'adv.rpt.col.effect': 'Effect',
  'adv.rpt.col.priority': 'Priority',
  'adv.rpt.bridge.opening': 'Result {year}',
  'adv.rpt.bridge.closing': 'Result {year}',
  'adv.rpt.bridge.revenue': 'Change in revenue',
  'adv.rpt.bridge.finance': 'Change in financial items',
  'adv.rpt.bridge.other': 'Other items ({count} lines)',
  'adv.rpt.bridge.readGuide': 'Read from left to right: start with last year’s result. Green raises the result, red lowers it. The final bar is this year’s result. Amounts below show each contribution.',
  'adv.rpt.bridge.readShort': 'Last year to this year · Green raises the result · Red lowers it',
  'adv.rpt.note.bridgeBasis': 'Lines with an effect below {amount} are grouped. The bridge runs from the {year} result to this year’s, and the drivers sum to the whole change.',
  'adv.rpt.empty.noBridgeBasis': 'Without booked figures for {year} the change cannot be broken down by driver.',
  'adv.rpt.empty.noBridgeChange': 'The result is unchanged from {year}.',
  'adv.rpt.metric.receivableDays': 'Receivables',
  'adv.rpt.metric.payableDays': 'Payables',
  'adv.rpt.metric.capitalGap': 'Net tied-up time',
  'adv.rpt.metric.measuredPaymentDays': 'Actual payment time',
  'adv.rpt.metric.netCapitalTied': 'Net capital tied up',
  'adv.rpt.note.capitalGapPositive': 'You wait {days} days longer for your money than you take to pay. That is the period operations must be funded from your own cash.',
  'adv.rpt.note.capitalGapNegative': 'You pay later than you get paid, so supplier credit funds part of operations.',
  'adv.rpt.note.capitalGapUnknown': 'Net tied-up time cannot be calculated because the revenue or cost basis is missing.',
  'adv.rpt.note.workingCapitalBasis': 'Receivable and payable days are estimates based on open items and {months} months of the reporting year. Actual payment time uses only paid customer invoices and is therefore a different calculation.',
  'adv.rpt.empty.noWorkingCapital': 'No open customer or supplier items to measure tied-up time on.',
  'adv.rpt.cell.vsPrevious12': 'vs previous 12',
  'adv.rpt.note.rollingBasis': 'The window is the last {months} booked months, so the comparison crosses the year end and is not hit by seasonality.',
  'adv.rpt.note.noRollingComparison': 'There is not enough history to compare against the preceding twelve months.',
  'adv.rpt.empty.noRollingBasis': 'Too little booked history to build a rolling twelve-month window.',
  'adv.rpt.certainty.planned': 'Planned',

  // ------------------------------------------------------------ Summary
  'adv.rpt.summary.profit': 'After {months} months of {year}, {income} in revenue has been booked and a profit of {result}.',
  'adv.rpt.summary.loss': 'After {months} months of {year}, {income} in revenue has been booked and a loss of {result}.',
  'adv.rpt.summary.margin': 'That gives a profit margin of {margin} %.',

  // ------------------------------------------------------------ Key figures
  'adv.rpt.kpi.income': 'Revenue',
  'adv.rpt.kpi.costs': 'Costs',
  'adv.rpt.kpi.result': 'Result',
  'adv.rpt.kpi.margin': 'Profit margin',
  'adv.rpt.kpi.revenue': 'Invoiced sales',
  'adv.rpt.kpi.invoiceCount': 'Invoice count',
  'adv.rpt.kpi.avgInvoice': 'Average per invoice',
  'adv.rpt.kpi.customerCount': 'Customer count',

  'adv.rpt.metric.receivables': 'Outstanding from customers',
  'adv.rpt.metric.payables': 'Owed to suppliers',
  'adv.rpt.metric.buffer': 'Liquidity buffer',
  'adv.rpt.metric.lowestBalance': 'Lowest balance in the year',
  'adv.rpt.metric.assets': 'Total assets',
  'adv.rpt.metric.equityAndDebt': 'Total equity and liabilities',
  'adv.rpt.metric.solidity': 'Equity ratio',
  'adv.rpt.metric.repeatRate': 'Returning customers',
  'adv.rpt.metric.avgPaymentDays': 'Average payment time',
  'adv.rpt.unit.days': '{days} days',

  // ------------------------------------------------------------ Tables
  'adv.rpt.col.line': 'Line',
  'adv.rpt.col.account': 'Account',
  'adv.rpt.col.budgetToDate': 'Budget to date',
  'adv.rpt.col.actual': 'Booked',
  'adv.rpt.col.variance': 'Variance',
  'adv.rpt.col.month': 'Month',
  'adv.rpt.col.in': 'In',
  'adv.rpt.col.out': 'Out',
  'adv.rpt.col.balance': 'Balance',
  'adv.rpt.col.certainty': 'Basis',
  'adv.rpt.col.income': 'Revenue',
  'adv.rpt.col.costs': 'Costs',
  'adv.rpt.col.result': 'Result',
  'adv.rpt.col.share': 'Share',
  'adv.rpt.chart.budgetActual': 'Budget versus booked to date',
  'adv.rpt.chart.monthlyResult': 'Monthly result',
  'adv.rpt.chart.incomeCosts': 'Monthly revenue and costs',
  'adv.rpt.chart.summaryResult': 'From revenue to result',
  'adv.rpt.chart.keyFiguresComparison': 'Key figures versus last year',
  'adv.rpt.chart.previousPeriod': 'Previous period',
  'adv.rpt.chart.currentPeriod': 'Current period',
  'adv.rpt.chart.cumulativeResult': 'Cumulative result through the year',
  'adv.rpt.chart.runningBalance': 'Running balance and liquidity buffer',
  'adv.rpt.chart.openItemsDue': 'Open items by due status',
  'adv.rpt.chart.workingCapitalGap': 'Capital tied up in open items',
  'adv.rpt.chart.balanceBasis': 'Booked balance groups',
  'adv.rpt.chart.bookedBalance': 'Booked balance',
  'adv.rpt.chart.capitalStructure': 'Capital structure',
  'adv.rpt.chart.equityShare': 'Equity',
  'adv.rpt.chart.otherFinancing': 'Other financing',
  'adv.rpt.chart.profit': 'Profit',
  'adv.rpt.chart.loss': 'Loss',
  'adv.rpt.col.amount': 'Amount',
  'adv.rpt.col.changeYoy': 'Change vs last year',
  'adv.rpt.col.status': 'Status',
  'adv.rpt.row.income': 'Revenue',
  'adv.rpt.row.costs': 'Costs',
  'adv.rpt.row.notDue': 'Not yet due',
  'adv.rpt.row.current': 'Not yet due',
  'adv.rpt.row.overdue': 'Overdue',
  'adv.rpt.row.total': 'Total',
  'adv.rpt.cell.vsPreviousYear': 'vs last year',
  'adv.rpt.cell.noBasis': 'No comparison',

  'adv.rpt.month.jan': 'January',
  'adv.rpt.month.feb': 'February',
  'adv.rpt.month.mar': 'March',
  'adv.rpt.month.apr': 'April',
  'adv.rpt.month.may': 'May',
  'adv.rpt.month.jun': 'June',
  'adv.rpt.month.jul': 'July',
  'adv.rpt.month.aug': 'August',
  'adv.rpt.month.sep': 'September',
  'adv.rpt.month.oct': 'October',
  'adv.rpt.month.nov': 'November',
  'adv.rpt.month.dec': 'December',
  'adv.rpt.certainty.confirmed': 'Booked',
  'adv.rpt.certainty.expected': 'Current month',
  'adv.rpt.certainty.uncertain': 'Not booked yet',

  // ------------------------------------------------------------ Budget
  'adv.rpt.budget.intro': 'Booked figures for {months} months of {year} are compared with the budget for those same months, not with the full-year budget.',

  // ------------------------------------------------------------ Vouchers
  'adv.rpt.vouchers.missing': '{count} booked purchases are missing a voucher, covering {net} in basis and {vat} in deducted VAT.',

  // ------------------------------------------------------------ Actions
  'adv.rpt.action.impact': '{label}: {value}',
  'adv.rpt.priority.high': 'High',
  'adv.rpt.priority.medium': 'Medium',
  'adv.rpt.priority.low': 'Low',
  'adv.rpt.severity.critical': 'Critical',
  'adv.rpt.severity.watch': 'Needs follow-up',
  'adv.rpt.severity.info': 'For information',

  // ------------------------------------------------------------ Decisions
  'adv.rpt.decision.risk': 'Decide on: {name}',
  'adv.rpt.decision.opportunity': 'Consider: {name}',
  'adv.rpt.decision.freeCapital': 'Decide how to use free capital of {amount}.',

  // ------------------------------------------------------------ Notes
  'adv.rpt.note.noPreviousYear': 'There are no booked figures for {year}, so change against last year cannot be calculated.',
  'adv.rpt.note.partialYear': 'The period is not closed. The figures cover {months} months of {year}.',
  'adv.rpt.note.noMaterialVariance': 'No individual line deviates materially from the budget.',
  'adv.rpt.note.unbudgeted': '{count} accounts have booked amounts with no budget line. They are included in the totals.',
  'adv.rpt.note.belowBuffer': 'The lowest calculated balance is {lowest}, below the selected buffer target of {buffer}.',
  'adv.rpt.note.aboveBuffer': 'The running balance stays above the buffer of {buffer} throughout the period.',
  'adv.rpt.note.forecastIsBooked': 'The curve is a running balance of booked figures, not a forecast model. Months with nothing booked yet stay flat.',
  'adv.rpt.note.balanceGrouping': 'Equity and liabilities are shown together, the way the trial balance groups them.',
  'adv.rpt.note.balanceInterimBasis': 'Balance groups are shown as booked on the report date. A difference between the sides may include the period result and must not be read as a completed annual balance.',
  'adv.rpt.note.noCustomerSplit': 'Sales are not split per customer in the source data.',
  'adv.rpt.note.concentration': '{name} accounts for {pct} % of invoiced sales.',
  'adv.rpt.note.customerBasis': 'Payment time is measured on invoices that have actually been paid.',
  'adv.rpt.note.costJump': 'One or more cost lines rose more than 25 % against last year.',
  'adv.rpt.note.topFiveOnly': 'Showing the five largest. The rest are in the totals but not listed.',
  'adv.rpt.note.vouchersComplete': 'Every booked purchase has a voucher.',
  'adv.rpt.note.vouchersRequired': 'Bookkeeping law requires documentation for each entry. Missing vouchers should be obtained before the period is reported.',
  'adv.rpt.note.overdueSales': '{amount} is overdue from customers and should be followed up.',
  'adv.rpt.note.overduePurchases': '{amount} is overdue to suppliers.',
  'adv.rpt.note.noRisks': 'No risk findings in the booked figures.',
  'adv.rpt.note.noActions': 'No actions are recommended right now.',
  'adv.rpt.note.notAProtocol': 'This is decision support and does not replace a board protocol. Resolutions are passed by the board.',

  // ------------------------------------------------------------ Empty states
  'adv.rpt.empty.noBookkeeping': 'No revenue or costs are booked for {year}. The report gets figures as soon as there are vouchers.',
  'adv.rpt.empty.noEvents': 'No material changes were registered in the period.',
  'adv.rpt.empty.noBudget': 'There is no budget for {year}. Add a budget to get variances in the report.',
  'adv.rpt.empty.noLiquidityBasis': 'No open customer or supplier items, and no booked movements to build the balance on.',
  'adv.rpt.empty.noForecast': 'A reconciled cash basis is unavailable for the balance curve.',
  'adv.rpt.empty.noBalance': 'The trial balance for {year} is empty.',
  'adv.rpt.empty.noSales': 'No invoiced sales are booked for {year}.',
  'adv.rpt.empty.noCustomerHistory': 'Too little customer history to measure repeat business and payment time.',
  'adv.rpt.empty.noCosts': 'No costs are booked for {year}.',
  'adv.rpt.empty.noSupplierSplit': 'Costs are not split per supplier in the source data.',
  'adv.rpt.empty.noReceivables': 'No outstanding customer items.',
  'adv.rpt.empty.noPayables': 'No outstanding supplier items.',
  'adv.rpt.empty.noDecisions': 'No matters require a decision right now.',

  // ------------------------------------------------------------ Data basis
  'adv.rpt.source.result': 'Income statement',
  'adv.rpt.source.balance': 'Trial balance',
  'adv.rpt.source.openItems': 'Open customer and supplier items',
  'adv.rpt.source.budget': 'Budget',
  'adv.rpt.source.bank': 'Bank movements',
  'adv.rpt.source.invoices': 'Customer invoices',
  'adv.rpt.source.purchases': 'Supplier invoices',
  'adv.rpt.source.vouchers': 'Vouchers',
  'adv.rpt.basis.generated': 'Generated {date}.',
  'adv.rpt.basis.period': 'The period covers {months} months of {year}.',
  'adv.rpt.basis.noPreviousYear': 'No booked figures for {year} — comparison against last year is missing.',
  'adv.rpt.basis.noBudget': 'No budget lines for {year}.',
  'adv.rpt.basis.noPartySplit': 'The customer and supplier breakdown is incomplete. The customer overview shows amounts that can be traced to invoiced sales.',
  'adv.rpt.basis.topFive': 'Customer and supplier lists show the five largest.',
  'adv.rpt.basis.bookedOnly': 'Accounting amounts come from the ledger. The buffer is a target, not a posted balance. Planned payments and calculated indicators are identified in the report.',

  // ------------------------------------------------------------ Monthly report
  'adv.rpt.period.monthShort': '{month}/{year}',
  'adv.rpt.period.vsPreviousMonth': 'versus the previous month',
  'adv.rpt.monthPicker.title': 'Choose a month for the monthly report',
  'adv.rpt.monthPicker.intro': 'Choose one of the last 24 calendar months. The report uses only booked figures, budget and comparisons for the selected month.',
  'adv.rpt.monthPicker.separate': 'The monthly report has its own month selection and is not affected by the year or quarter selection used by other reports.',
  'adv.rpt.monthPicker.continue': 'Choose month',
  'adv.rpt.monthPicker.back': 'Back to report templates',
  'adv.rpt.monthPicker.generate': 'Generate monthly report',
  'adv.rpt.sec.monthlyStatus': 'Status for the month',
  'adv.rpt.sec.monthlyBudget': 'Month versus budget',
  'adv.rpt.sec.monthlyComparison': 'Same month last year',
  'adv.rpt.sec.monthlyTrend': 'Development over the last 12 months',
  'adv.rpt.sec.monthlyInsights': 'Monthly assessment and next steps',
  'adv.rpt.empty.noMonthlyBudget': 'There is no budget for the selected month.',
  'adv.rpt.empty.noMonthlyComparison': 'There are no booked figures for the same month last year.',
  'adv.rpt.empty.noMonthlyTrend': 'There are no booked monthly figures in the twelve-month window.',
  'adv.rpt.col.budget': 'Budget',
  'adv.rpt.col.variancePct': 'Variance %',
  'adv.rpt.row.result': 'Result',
  'adv.rpt.chart.monthBudgetActual': 'Budget and actuals for the month',
  'adv.rpt.chart.sameMonthComparison': 'Selected month versus the same month last year',
  'adv.rpt.metric.averageMonthlyResult': 'Average monthly result',
  'adv.rpt.metric.bestMonthlyResult': 'Best month',
  'adv.rpt.metric.weakestMonthlyResult': 'Weakest month',
  'adv.rpt.monthly.statusProfit': 'The month ended with a profit of {result} and a result margin of {margin}%.',
  'adv.rpt.monthly.statusLoss': 'The month ended with a loss of {result} and a result margin of {margin}%.',
  'adv.rpt.monthly.budgetAbove': 'The result is {amount} better than the budget for the month.',
  'adv.rpt.monthly.budgetBelow': 'The result is {amount} weaker than the budget for the month.',
  'adv.rpt.monthly.marginChange': 'The result margin changed by {change} percentage points from the same month last year.',
  'adv.rpt.monthly.trendBasis': 'The development shows up to 12 booked calendar months through the selected month.',
  'adv.rpt.monthly.insightLossTitle': 'Negative monthly result',
  'adv.rpt.monthly.insightLossBody': 'Costs exceeded revenue by {amount} in the selected month.',
  'adv.rpt.monthly.insightProfitTitle': 'Positive monthly result',
  'adv.rpt.monthly.insightProfitBody': 'The month generated a profit of {amount}. Follow up which revenue and cost drivers should be repeated.',
  'adv.rpt.monthly.insightIncomeDownTitle': 'Revenue lower than last year',
  'adv.rpt.monthly.insightIncomeDownBody': 'Revenue is {change}% lower than in the same month last year.',
  'adv.rpt.monthly.insightCostsTitle': 'Costs above budget',
  'adv.rpt.monthly.insightCostsBody': 'Costs are {amount} above the budget for the month.',
  'adv.rpt.monthly.insightBudgetTitle': 'Result behind budget',
  'adv.rpt.monthly.insightBudgetBody': 'The result is {amount} weaker than the budget for the month.',
  'adv.rpt.monthly.stepReviewDrivers': 'Review the entries explaining the monthly result and clarify which effects are lasting.',
  'adv.rpt.monthly.stepRevenue': 'Follow up the revenue decline against the same month last year.',
  'adv.rpt.monthly.stepCosts': 'Identify the costs that are above the monthly budget.',
  'adv.rpt.monthly.stepBudget': 'Update the actions needed to close the result variance against the monthly budget.',
  'adv.rpt.monthly.stepContinue': 'Preserve the drivers behind the positive monthly result and monitor development next month.',
});
